import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { CompanyEntity } from './company.entity';
import { WarehouseEntity } from './warehouse.entity';

@Index('fk_company__id', ['fkCompanyId'], {})
@Index('fk_warehouse__id', ['fkWarehouseId'], {})
@Entity('company_warehouse')
export class CompanyWarehouseEntity extends BaseEntity {
	@Column('int', { name: 'fk_company__id', unsigned: true })
	public fkCompanyId!: number;

	@Column('int', { name: 'fk_warehouse__id', unsigned: true })
	public fkWarehouseId!: number;

	@ManyToOne(() => CompanyEntity, (company) => company.companyWarehouses, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_company__id', referencedColumnName: 'id' }])
	public fkCompany!: CompanyEntity;

	@ManyToOne(
		() => WarehouseEntity,
		(warehouse) => warehouse.companyWarehouses,
		{
			onDelete: 'RESTRICT',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: 'fk_warehouse__id', referencedColumnName: 'id' }])
	public fkWarehouse!: WarehouseEntity;
}
